import {z} from 'zod'
import {
  PrimerComponentCtaBannerSchema,
  PrimerComponentHeroSchema,
  PrimerComponentRiverSchema,
  PrimerComponentSectionIntroSchema,
  PrimerPillarsSchema,
  TemplateFreeFormSchema,
  TemplateFreeFormSectionSchema,
} from '../../../../lib/types/contentful'

export const DiversityTemplateSchema = TemplateFreeFormSchema.extend({
  fields: z.object({
    sections: z.tuple([
      TemplateFreeFormSectionSchema.extend({
        fields: z.object({
          components: z.tuple([PrimerComponentHeroSchema]),
        }),
      }),

      TemplateFreeFormSectionSchema.extend({
        fields: z.object({
          components: z.tuple([PrimerComponentRiverSchema, PrimerComponentSectionIntroSchema, PrimerPillarsSchema]),
        }),
      }),

      TemplateFreeFormSectionSchema.extend({
        fields: z.object({
          components: z.tuple([PrimerComponentRiverSchema, PrimerComponentSectionIntroSchema, PrimerPillarsSchema]),
        }),
      }),

      TemplateFreeFormSectionSchema.extend({
        fields: z.object({
          components: z.tuple([PrimerComponentRiverSchema, PrimerPillarsSchema]),
        }),
      }),

      TemplateFreeFormSectionSchema.extend({
        fields: z.object({
          components: z.tuple([PrimerComponentRiverSchema, PrimerPillarsSchema]),
        }),
      }),

      TemplateFreeFormSectionSchema.extend({
        fields: z.object({
          components: z.tuple([PrimerComponentCtaBannerSchema]),
        }),
      }),
    ]),
  }),
})

export type DiversityTemplate = z.infer<typeof DiversityTemplateSchema>

export function toDiversityTemplate(entry: unknown): DiversityTemplate {
  return DiversityTemplateSchema.parse(entry)
}
